<template>
  <full-container :key="queryParams.timestamp">
    <div class="toolbar" slot="header">
      <el-form
        :model="queryParams"
        :inline="true"
        size="small"
        class="search-form"
      >
        <el-form-item>
          <template v-for="key in Object.keys(queryParams)">
            <el-tag
              v-if="
                key != 'timestamp' &&
                key != 'dealtime' &&
                key != 'product' &&
                key != 'minPrice' &&
                key != 'maxPrice' &&
                queryParams[key]
              "
              :key="key"
              effect="dark"
              closable
              :disable-transitions="false"
              @close="changeParams(key)"
              >{{ queryParams[key] }}</el-tag
            >
          </template>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="queryParams.dealtime"
            type="monthrange"
            value-format="yyyy-MM"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeParams()"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="queryParams.product"
            prefix-icon="el-icon-shopping-bag-2"
            clearable
            placeholder="商品查询"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="changeParams()"
            />
          </el-input>
        </el-form-item>
        <el-form-item class="flexItem">
          <el-input
            v-model="queryParams.minPrice"
            clearable
            placeholder="最低单价"
          >
            <span style="padding: 0 5px" slot="prefix">￥</span>
          </el-input>
          <label class="margin:0 10px;">-</label>
          <el-input
            v-model="queryParams.maxPrice"
            clearable
            placeholder="最高单价"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="changeParams()"
            />
          </el-input>
        </el-form-item>
      </el-form>
      <ul class="amounts" v-if="queryParams.dealer && dealerAbout">
        <li>
          <h3>第{{ dealerAbout.ranking }}位</h3>
          <label>综合排名</label>
        </li>
        <li>
          <h3>{{ dealerAbout.total }}万</h3>
          <label>交易总额</label>
        </li>
        <li>
          <h3>{{ dealerAbout.purchaser }}家</h3>
          <label>涉及客户</label>
        </li>
      </ul>
      <ul class="amounts" v-else-if="queryParams.purchaser && purchaserAbout">
        <li>
          <h3>第{{ purchaserAbout.ranking }}位</h3>
          <label>综合排名</label>
        </li>
        <li>
          <h3>{{ purchaserAbout.total }}万</h3>
          <label>交易总额</label>
        </li>
        <li>
          <h3>{{ purchaserAbout.dealer }}家</h3>
          <label>涉及经销商</label>
        </li>
      </ul>
    </div>
    <monthChart
      v-if="
        !queryParams.dealtime ||
        queryParams.dealtime[0] != queryParams.dealtime[1]
      "
      ref="productCom"
      :params="queryParams"
      style="min-height: 360px"
    />
    <modeChart
      v-if="!queryParams.mode"
      ref="modeCom"
      :params="queryParams"
      style="min-height: 360px"
    >
      <h3>采购方式</h3>
    </modeChart>
    <regionChart
      v-if="!queryParams.region && !queryParams.purchaser"
      ref="regionCom"
      :params="queryParams"
      style="min-height: 360px"
    >
      <h3>覆盖地区</h3>
    </regionChart>
    <categoryChart
      v-if="!queryParams.category && !queryParams.product"
      ref="categoryCom"
      :params="queryParams"
      style="min-height: 360px"
    >
      <h3>采购品类</h3>
    </categoryChart>
    <dealerList
      v-if="!queryParams.dealer || dealerAbout.same > 1"
      ref="dealerCom"
      :params="queryParams"
      style="min-height: 360px"
    >
      <h3>经销商 TOP10</h3>
    </dealerList>
    <purchaserList
      v-if="!queryParams.purchaser"
      ref="purchaserCom"
      :params="queryParams"
      style="min-height: 360px"
    >
      <h3>客户 TOP10</h3>
    </purchaserList>
    <productList
      v-if="!queryParams.product"
      ref="productCom"
      :params="queryParams"
      style="min-height: 360px"
    >
      <h3>热销商品 TOP10</h3>
    </productList>
  </full-container>
</template>

<script>
export default {
  components: {
    modeChart: () => import("./charts/_mode.vue"),
    regionChart: () => import("./charts/_region.vue"),
    categoryChart: () => import("./charts/_category.vue"),
    monthChart: () => import("./charts/_month.vue"),
    dealerList: () => import("./charts/_dealer_li.vue"),
    purchaserList: () => import("./charts/_purchaser_li.vue"),
    productList: () => import("./charts/_product_li.vue"),
  },
  data() {
    return {
      queryParams: this.$route.query,
      dealerAbout: {},
      purchaserAbout: {},
    };
  },
  methods: {
    changeParams(key = null) {
      let query = JSON.parse(JSON.stringify(this.queryParams));
      if (key && query[key]) {
        delete query[key];
      }
      this.$set(query, "timestamp", new Date().getTime());
      this.$router.replace({ query });
    },
    loadDealer() {
      this.$apis.trend.dealer.about(this.queryParams).then((res) => {
        this.dealerAbout = res;
      });
    },
    loadPurchaser() {
      this.$apis.trend.purchaser.about(this.queryParams).then((res) => {
        this.purchaserAbout = res;
      });
    },
  },
  watch: {
    $route: {
      handler(to) {
        console.log(to);
        if (to.path == "/trend/detail") {
          this.queryParams = { ...to.query, timestamp: new Date().getTime() };
          if (to.query.dealer) {
            this.loadDealer();
          } else if (to.query.purchaser) {
            this.loadPurchaser();
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-scrollbar) {
  &__view {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px;
    height: auto !important;
  }
}
ul.amounts {
  display: flex;
  flex-direction: row;
  li {
    list-style: none;
    text-align: center;
    label {
      color: #909399;
      font-size: 12px;
    }
  }
  li + li {
    margin-left: 20px;
  }
}
.flexItem {
  background: #fff;
  border-radius: 4px;
  height: 32px;
  width: 280px;
  overflow: hidden;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  :deep(.el-input) {
    &__inner {
      border: unset;
      text-align: center;
    }
    &-group__append {
      border: unset;
      border-left: 1px solid #dcdfe6;
    }
  }
}
</style>